// FullCalendarのみ一番上にimportする
// 「Please import the top-level fullcalendar lib before attempting to import a plugin.」
// eslint-disable-next-line import/order
import FullCalendar from '@fullcalendar/react';

import {
  ViewApi,
  Duration,
  EventSourceFunc,
  EventApi,
  EventInput,
  DatesSetArg,
  AllowFunc,
  MoreLinkMountArg,
} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import React from 'react';

// eslint-disable-next-line no-restricted-imports
import './calendar.scss';

type CalendarProps = {
  editable?: boolean;
  height?: number | string;
  expandRows?: boolean;
  dayMaxEvents?: boolean | number;
  events?: string | EventSourceFunc | EventInput[] | undefined;
  eventClick: (arg: { el: HTMLElement; event: EventApi; jsEvent: MouseEvent; view: ViewApi }) => boolean | void;
  dateClick?: (arg: {
    date: Date;
    dateStr: string;
    allDay: boolean;
    resource?: any;
    dayEl: HTMLElement;
    jsEvent: MouseEvent;
    view: ViewApi;
  }) => void;
  eventDrop?: (arg: {
    el: HTMLElement;
    event: EventApi;
    oldEvent: EventApi;
    delta: Duration;
    revert: () => void;
    jsEvent: Event;
    view: ViewApi;
  }) => void;
  datesSet?: (arg: DatesSetArg) => void;
  eventAllow?: AllowFunc;
};

// FullCalendarが確保した表示領域は変えずに、「他N件」だけを日付セルの下端へ移動する
const alignMoreLinkToDayCellBottom = (element: HTMLElement) => {
  const dayCell = element.closest<HTMLElement>('.fc-daygrid-day');
  if (!dayCell) return;

  element.style.display = 'inline-block';
  element.style.transform = '';
  const bottomSpace = dayCell.getBoundingClientRect().bottom - element.getBoundingClientRect().bottom - 2;
  element.style.transform = bottomSpace > 0 ? `translateY(${bottomSpace}px)` : '';
};

// 「他N件」の表示時に左下へ移動する
const handleMoreLinkDidMount = (arg: MoreLinkMountArg) => {
  alignMoreLinkToDayCellBottom(arg.el);
};

// 画面サイズの変更後に、表示中の「他N件」の位置を更新する
const handleWindowResize = () => {
  document.querySelectorAll<HTMLElement>('.fc-daygrid-more-link').forEach(alignMoreLinkToDayCellBottom);
};

export const Calendar = (props: CalendarProps) => {
  return (
    <FullCalendar
      locale="ja"
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      headerToolbar={{
        start: 'prev,next today',
        center: 'title',
        end: 'dayGridMonth,timeGridWeek,timeGridDay',
      }}
      buttonText={{
        prev: '前',
        next: '次',
        prevYear: '前年',
        nextYear: '次年',
        today: '今日',
        month: '月',
        week: '週',
        day: '日',
      }}
      dayMaxEvents={5}
      dayMaxEventRows={5}
      moreLinkContent={(arg) => `他${arg.num}件`}
      moreLinkDidMount={handleMoreLinkDidMount}
      windowResize={handleWindowResize}
      eventTimeFormat={(arg) => `${arg.start.hour}:${('00' + arg.start.minute).slice(-2)}`}
      {...props}
    />
  );
};

export default Calendar;
